import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import { DEMO_ACCOUNTS } from '../../constants';

const USE_API = import.meta.env.VITE_USE_API === 'true';

export default function LoginScreen() {
  const { login, loginWithCredentials, toast } = useApp();
  const [email, setEmail] = useState('');
  const [pwd, setPwd] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const doLogin = async () => {
    if (!email || !pwd) { setError('Email and password are required'); return; }
    setLoading(true); setError('');
    try {
      if (USE_API) {
        await loginWithCredentials(email, pwd);
      } else {
        const user = DEMO_ACCOUNTS.find(u => u.email === email && u.pwd === pwd);
        if (user) login(user);
        else setError('Invalid credentials. Try a demo account below.');
      }
    } catch (e) {
      setError((e as Error).message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #0F1B2D 0%, #1A2D45 50%, #0F1B2D 100%)' }}>
      <div style={{ position: 'fixed', inset: 0, opacity: 0.04, backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)', backgroundSize: '28px 28px', pointerEvents: 'none' }} />
      <div style={{ background: 'white', borderRadius: '20px', padding: '40px', width: '100%', maxWidth: '420px', boxShadow: '0 32px 80px rgba(0,0,0,0.5)', position: 'relative' }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ width: '52px', height: '52px', borderRadius: '14px', background: '#C8973A', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px', fontSize: '22px', fontWeight: '800', color: '#0F1B2D' }}>e</div>
          <div style={{ fontSize: '22px', fontWeight: '800', color: '#0F1B2D', fontFamily: "'DM Serif Display', serif" }}>effyBiz SalesBook</div>
          <div style={{ fontSize: '13px', color: '#718096', marginTop: '4px' }}>
            {USE_API ? 'Connected to backend API' : 'Running in demo mode'}
          </div>
        </div>
        <div>
          <label style={{ display: 'block', fontSize: '11px', fontWeight: '600', color: '#4A5568', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: '5px' }}>Email</label>
          <input type="email" value={email} onChange={e => { setEmail(e.target.value); setError(''); }}
            placeholder="you@company.com" onKeyDown={e => e.key === 'Enter' && doLogin()}
            style={{ width: '100%', padding: '10px 13px', border: '1.5px solid #E2E8F0', borderRadius: '9px', fontFamily: 'inherit', fontSize: '14px', marginBottom: '14px', outline: 'none', boxSizing: 'border-box' }} />
          <label style={{ display: 'block', fontSize: '11px', fontWeight: '600', color: '#4A5568', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: '5px' }}>Password</label>
          <input type="password" value={pwd} onChange={e => { setPwd(e.target.value); setError(''); }}
            placeholder="••••••••" onKeyDown={e => e.key === 'Enter' && doLogin()}
            style={{ width: '100%', padding: '10px 13px', border: '1.5px solid #E2E8F0', borderRadius: '9px', fontFamily: 'inherit', fontSize: '14px', marginBottom: '6px', outline: 'none', boxSizing: 'border-box' }} />
          {error && <div style={{ fontSize: '12px', color: '#EF4444', marginBottom: '10px' }}>{error}</div>}
          <button onClick={doLogin} disabled={loading}
            style={{ width: '100%', padding: '11px', borderRadius: '9px', background: loading ? '#CBD5E0' : '#C8973A', border: 'none', color: 'white', fontFamily: 'inherit', fontSize: '14px', fontWeight: '700', cursor: loading ? 'wait' : 'pointer', marginTop: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
            {loading ? <><i className="ti ti-loader-2" style={{ animation: 'spin 1s linear infinite' }} /> Signing in…</> : 'Sign in →'}
          </button>
        </div>
        <div style={{ marginTop: '28px', paddingTop: '22px', borderTop: '1px solid #E2E8F0' }}>
          <div style={{ fontSize: '10px', fontWeight: '700', color: '#718096', textTransform: 'uppercase', letterSpacing: '.08em', marginBottom: '10px', textAlign: 'center' }}>Demo accounts</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '7px' }}>
            {DEMO_ACCOUNTS.map(a => (
              <button key={a.email} onClick={() => { setEmail(a.email); setPwd(a.pwd); setError(''); }}
                style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '9px 12px', borderRadius: '9px', border: '1.5px solid #E2E8F0', background: 'white', cursor: 'pointer', fontFamily: 'inherit', textAlign: 'left', transition: 'all .15s' }}
                onMouseEnter={e => (e.currentTarget.style.borderColor = '#C8973A')}
                onMouseLeave={e => (e.currentTarget.style.borderColor = '#E2E8F0')}>
                <div style={{ width: '32px', height: '32px', borderRadius: '50%', background: a.color, color: 'white', fontSize: '11px', fontWeight: '700', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{a.ini}</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: '13px', fontWeight: '600', color: '#1A202C' }}>{a.name}</div>
                  <div style={{ fontSize: '11px', color: '#718096' }}>{a.title} · {a.role}</div>
                </div>
                <div style={{ fontSize: '10px', color: '#C8973A', fontWeight: '600' }}>Use →</div>
              </button>
            ))}
          </div>
        </div>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
